module.exports = __webpack_public_path__ + "static/ENdeskSlide3-96c4449c1637ed6e0d90bcde886f50b7.png";